import React, { useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { useDispatch } from "react-redux";
import IntlMessages from "../../../../util/IntlMessages";
import { Button, Input, Message, Switch } from "../../../BP2Components";
import { setWidgetInSheetParams } from "../../../../appRedux/actions/Boards";
import "../GlobalSettings/GlobalSettings.less";
import "../../InfiniteListWidget/InfiniteList.less";

interface InfiniteListSettingsProps {
   value: any;
}

interface Profile {
   profileId: number | null;
   profileName: string;
}

type SysActionType =
   | "showMoveForward"
   | "showAskQuestion"
   | "showProcessData"
   | "showScheduleData"
   | "showTags";

const InfiniteListSettings: React.FC<InfiniteListSettingsProps> = ({ value }) => {
   const [listId, setListId] = useState(value?.listId);
   const [profiles, setProfiles] = useState<Profile[]>([]);
   const [profileId, setProfileId] = useState<number | null>(null);
   const [profileName, setProfileName] = useState<string>("");
   const [sysActionsVisibility, setSysActionsVisibility] = useState(value?.sysActionsVisibility);

   const handleSysActionsVisibilityChange = (action: SysActionType, inputValue: boolean) => {
      setSysActionsVisibility((prevState) => ({
         ...prevState,
         [action]: inputValue
      }));
   };

   const dispatch = useDispatch();
   const intl = useIntl();

   const handleListIdChange = (e) => {
      setListId(parseInt(e.target.value));
   };

   const handleSubmit = () => {
      const newSettings = {
         ...value,
         listId,
         sysActionsVisibility: sysActionsVisibility,
         profileList: profiles
      };

      dispatch(setWidgetInSheetParams(newSettings));
      Message.success(intl.formatMessage({ id: "global.saved" }));
   };

   const addProfile = (e) => {
      if (profileName.trim() !== "" && profileId !== null) {
         const newProfile: Profile = { profileId, profileName };
         setProfiles((prevProfiles) => [...prevProfiles, newProfile]);
         setProfileId(null);
         setProfileName("");
      }
   };

   return (
      <div className="widget-settings">
         <div className="widget-settings__inner">
            <div className="widget-settings__inner__label">
               <IntlMessages id="settings.listId" />
               <Input
                  defaultValue={value?.listId}
                  placeholder={value?.listId}
                  type="number"
                  style={{ width: "40%", minWidth: "150px" }}
                  onChange={(e) => handleListIdChange(e)}
               />
            </div>

            <div className="widget-settings__inner__label">
               <p className="add-profile-title">
                  <IntlMessages id="settings.addProfile" />
               </p>
               <div className="profile-add-container">
                  <Input
                     type="number"
                     className="profile-id-settings-input"
                     placeholder={intl.formatMessage({
                        id: "settings.profileId"
                     })}
                     value={profileId !== null ? profileId.toString() : undefined}
                     onChange={(e) =>
                        setProfileId(e.target.value !== null ? Number(e.target.value) : null)
                     }
                  />
                  <Input
                     type="text"
                     className="profile-name-settings-input"
                     placeholder={intl.formatMessage({
                        id: "settings.profileName"
                     })}
                     value={profileName}
                     onChange={(e) => setProfileName(e.target.value)}
                  />
                  <Button onClick={addProfile} className="add-profile-btn">
                     <IntlMessages id="bp2.buttonWidget.Add" />
                  </Button>
               </div>
            </div>
            <div className="profiles-list-container">
               <p>
                  <IntlMessages id="settings.addedProfiles" />:
               </p>

               {profiles?.map((profile, index) => (
                  <div key={index}>
                     <span>
                        <IntlMessages id="settings.profileId" />:
                        <span className="added-profile-value">{profile?.profileId}</span>
                     </span>
                     <span>
                        <IntlMessages id="settings.profileName" />:
                        <span className="added-profile-value">{profile?.profileName}</span>
                     </span>
                  </div>
               ))}
            </div>

            <div className="sys-actions-visibility-container">
               <div className="sys-actions-visibility-container__label">
                  <span className="name">
                     <IntlMessages id="settings.changeMoveForwardVisibilty" />
                  </span>
                  <Switch
                     defaultChecked={sysActionsVisibility?.showMoveForward || null}
                     onChange={(e) => handleSysActionsVisibilityChange("showMoveForward", e)}
                  />
               </div>
               <div className="sys-actions-visibility-container__label">
                  <span className="name">
                     <IntlMessages id="settings.changeAskQuestionVisibility" />
                  </span>
                  <Switch
                     defaultChecked={sysActionsVisibility?.showAskQuestion || null}
                     onChange={(e) => handleSysActionsVisibilityChange("showAskQuestion", e)}
                  />
               </div>
            </div>
         </div>
         <Button
            onClick={handleSubmit}
            buttonType="primary"
            htmlType="submit"
            style={{ marginTop: "20px" }}
         >
            <IntlMessages id="global.preview" />
         </Button>
      </div>
   );
};

export default InfiniteListSettings;
